import React, { useEffect } from 'react';
import gql from 'graphql-tag';
import Helmet from 'react-helmet';
import { useSegmentClient } from '@redbubble/react-segment';
import WorkModal from '../../components/WorkModal';
import WorkMetaData from '../../components/WorkMetaData';
import useSendImpressions from '../../hooks/useSendImpressions';

import messages from './messages';

const WorkModalWithMetaData = props => {
  const { loading, error, work, intl, userInfo } = props;
  const segmentClient = useSegmentClient();

  useSendImpressions();
  useEffect(() => {
    const { currency, locale, country } = userInfo;
    segmentClient.page('Explore Work', { currency, locale, country });
  }, []);

  if (loading) return null;
  if (error || !work) return null;

  const { title, artistShopDisplayName } = work;

  const localisedTitle = intl.formatMessage(messages.WorkByArtist, {
    workTitle: title,
    artistName: artistShopDisplayName
  });

  return (
    <div>
      <Helmet>
        <meta name="robots" content="noindex" />
      </Helmet>
      <WorkModal {...props} title={localisedTitle} />
      <WorkMetaData {...props} title={localisedTitle} />
    </div>
  );
};

WorkModalWithMetaData.displayName = 'WorkModalWithMetaData';

WorkModalWithMetaData.fragment = gql`
  fragment WorkModalWithMetaData on Work {
    ...${WorkModal.displayName},
    ...${WorkMetaData.displayName},
  }
  ${WorkModal.fragment}
  ${WorkMetaData.fragment}
`;

export const fragments = [
  {
    type: 'Work',
    name: WorkModalWithMetaData.displayName,
    fragment: WorkModalWithMetaData.fragment
  }
];

export default WorkModalWithMetaData;
